import React from 'react';

const trustItems = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M8.25 18.75a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 01-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m3 0h1.125c.621 0 1.125-.504 1.125-1.125v-3.375c0-.621-.504-1.125-1.125-1.125H18M8.25 18.75l.75-8.25h6l.75 8.25M2.25 14.25h4.5M18 13.5V6.75a.75.75 0 00-.75-.75H13.5" />
      </svg>
    ),
    title: 'Fraktfritt',
    subtitle: 'Vid köp över 349 kr',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
    title: 'Snabb leverans',
    subtitle: '1–3 arbetsdagar',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 12.75L11.25 15 15 9.75m-3-7.036A11.959 11.959 0 013.598 6 11.99 11.99 0 003 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285z" />
      </svg>
    ),
    title: 'Säker betalning',
    subtitle: 'Klarna & kortbetalning',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round">
        <path d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
      </svg>
    ),
    title: 'Nya posters',
    subtitle: 'Uppdateras varje vecka',
  },
];

const SubSectionsCard = ({ isMobileView }) => {
  return (
    <section style={{
      borderTop: '1px solid #eaeaea',
      background: '#fafafa',
      padding: isMobileView ? '40px 16px' : '56px 24px',
    }}>
      <div style={{
        maxWidth: 1100,
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: isMobileView ? '1fr 1fr' : 'repeat(4, 1fr)',
        gap: isMobileView ? 20 : 0,
      }}>
        {trustItems.map((item, index) => (
          <div
            key={index}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: isMobileView ? '20px 12px' : '24px 20px',
              borderRight: !isMobileView && index < trustItems.length - 1 ? '1px solid #eaeaea' : 'none',
              position: 'relative',
            }}
          >
            {/* Icon circle */}
            <div style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              backgroundColor: '#161825',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 16,
            }}>
              {item.icon}
            </div>

            {/* Title */}
            <div style={{
              fontSize: 15,
              fontWeight: 700,
              color: '#161825',
              lineHeight: 1.3,
              marginBottom: 4,
            }}>
              {item.title}
            </div>

            {/* Subtitle */}
            <div style={{
              fontSize: 13,
              color: '#888',
              lineHeight: 1.4,
              fontWeight: 400,
            }}>
              {item.subtitle}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SubSectionsCard;
